module["exports"] = [
  "Dr.",
  "Prof."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nb_NO/name/prefix.js
// module id = 1050
// module chunks = 0